import { getToken, axiosInstance } from "../../utils/Api";

export const getQuizzes = async () => {
  try {
    const response = await axiosInstance.get("/admin/quiz/list", {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getQuizData = async (id) => {
  try {
    const response = await axiosInstance.get(`/admin/quiz/get?id=${id}`, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createQuiz = async (quizData) => {
  try {
    const response = await axiosInstance.post("/admin/quiz/create", quizData, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateQuiz = async (quizData) => {
  try {
    const response = await axiosInstance.put("/admin/quiz/update", quizData, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteQuiz = async (id) => {
  try {
    const response = await axiosInstance.delete("/admin/quiz/delete", {
      data: { id },
      headers: {
        Authorization: `Bearer ${getToken()}`,
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const uploadQuizMedia = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const response = await axiosInstance.post("/admin/quiz/uploadMedia", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${getToken()}`,
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
